export var URL = "";
export var URL5 = "";
export var APPID = "";
export var envVersion = "";
// 潜客绑定路径
export var weixinxcx = "";

// 商用净水小程序路径
export var URL_BUSINESS_XCX = "";

// VUE_APP_FLAG == 'development'  开发环境
// VUE_APP_FLAG == 'test'  测试环境
// VUE_APP_FLAG == 'production'  线上环境

if (process.env.VUE_APP_FLAG == 'development') {

    URL = "https://aotest.iwxapi.com/Api";
    URL5 = "http://aotest-lottery.iwxapi.com/";
    APPID = "wxb3791b45aaf3d47a";
    envVersion = "trial";
    weixinxcx = "weixin://dl/business/?t=8tEAHNkinil";
    URL_BUSINESS_XCX = "weixin://dl/business/?t=0ChdwLgsSum";
} else if (process.env.VUE_APP_FLAG == 'test') {

    URL = "https://aotest.iwxapi.com/Api";
    URL5 = "https://aotest-lottery.iwxapi.com/";
    APPID = "wxb3791b45aaf3d47a";
    envVersion = "trial";
    weixinxcx = "weixin://dl/business/?t=8tEAHNkinil";
    URL_BUSINESS_XCX = "weixin://dl/business/?t=0ChdwLgsSum";

} else if (process.env.VUE_APP_FLAG == 'production') {

    URL = "https://aosmith.iwxapi.com/Api"
    URL5 = "https://aosmith-lottery.iwxapi.com/"
    APPID = "wx3962a8c2ee7612a5"
    envVersion = "release"
    weixinxcx = "weixin://dl/business/?t=e034cHY9cSe";
    URL_BUSINESS_XCX = "weixin://dl/business/?t=mBep0rR1wyi";

}

export default {
    URL,
    URL5,
    APPID,
    envVersion,
    weixinxcx,
    URL_BUSINESS_XCX
};

